import { computed, type Ref } from 'vue';
import { isDirectoryTitleValid } from '../config/directoryTitle';
import type { DirectoryIconId } from './types';
import { isDirectoryIconId } from '@/shared/ui/module-icons';

export interface CreateModuleSubmitPayload {
  name: string;
  iconId?: DirectoryIconId;
}

export function useCreateModuleForm(title: Ref<string>, iconId: Ref<string>) {
  const trimmedTitle = computed(() => title.value.trim());

  const isTitleValid = computed(() => isDirectoryTitleValid(title.value));

  const resolvedIconId = computed((): DirectoryIconId | undefined => {
    if (isDirectoryIconId(iconId.value)) {
      return iconId.value;
    }
    return undefined;
  });

  const reset = () => {
    title.value = '';
    iconId.value = '';
  };

  const buildSubmitPayload = (): CreateModuleSubmitPayload => ({
    name: trimmedTitle.value,
    iconId: resolvedIconId.value,
  });

  return {
    trimmedTitle,
    isTitleValid,
    resolvedIconId,
    reset,
    buildSubmitPayload,
  };
}
